"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var times_1 = __importDefault(require("lodash/times"));
moment_timezone_1.default.tz.setDefault('America/New_York');
;
var dates = {};
var generateDates = function (year) {
    var profileTime = moment_timezone_1.default(year, 'Y');
    return times_1.default(profileTime.isLeapYear() ? 8784 : 8760, function (hourOfYear) {
        var val = {
            month: profileTime.month(),
            dayOfWeek: profileTime.day(),
            hourStart: profileTime.hour(),
            date: profileTime.format('YYYY-MM-DD'),
            hourOfYear: hourOfYear,
        };
        profileTime.add(1, 'hour');
        return val;
    });
};
exports.default = (function (year) {
    if (!dates[year]) {
        dates[year] = generateDates(year);
    }
    return dates[year];
});
